import { useEffect, useState } from 'react';
import logo from '../assets/logo/logo_transparent_background.png';
import styles from './Header.module.css';

const LINKS = [
  ['#services', 'Services'],
  ['#ai', 'AI Solutions'],
  ['#portfolio', 'Portfolio'],
  ['#cases', 'Case Studies'],
  ['#about', 'About'],
  ['#contact', 'Contact'],
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`} id="header">
        <div className="wrap">
          <nav className={styles.nav}>
            <a className={styles.brand} href="#top" aria-label="JP Custom Works home">
              <img src={logo} alt="JP Custom Works logo — coral-red faceted gem with company name" />
            </a>
            <div className={styles.navLinks}>
              {LINKS.map(([href, label]) => (
                <a key={href} href={href}>
                  {label}
                </a>
              ))}
            </div>
            <div className={styles.navActions}>
              <a href="/portal" className={styles.clientLogin}>
                Client Login
              </a>
              <a href="#contact" className="btn btn-primary">
                Start a Conversation
              </a>
              <button
                className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`}
                aria-label="Toggle menu"
                aria-expanded={menuOpen}
                aria-controls="mobileMenu"
                onClick={() => setMenuOpen((o) => !o)}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </nav>
        </div>
      </header>

      <div className={`${styles.mobileMenu} ${menuOpen ? styles.open : ''}`} id="mobileMenu">
        {LINKS.map(([href, label]) => (
          <a key={href} href={href} onClick={() => setMenuOpen(false)}>
            {label}
          </a>
        ))}
        <a href="/portal" onClick={() => setMenuOpen(false)}>
          Client Login
        </a>
        <a href="#contact" className={`btn btn-primary ${styles.menuCta}`} onClick={() => setMenuOpen(false)}>
          Start a Conversation
        </a>
      </div>
    </>
  );
}
